<template>
  <div class="picture-code">
    <canvas
      id="picture-code"
      :width="contentWidth"
      :height="contentHeight"
    ></canvas>
  </div>
</template>

<script>
export default {
  name: "PictureCode",
  props: {
    code: {
      // 默认注册码
      type: String,
      default: "1234",
    },
    fontSizeMin: {
      // 字体最小值
      type: Number,
      default: 24,
    },
    fontSizeMax: {
      // 字体最大值
      type: Number,
      default: 32,
    },
    backgroundColorMin: {
      // 验证码图片背景色最小值
      type: Number,
      default: 255,
    },
    backgroundColorMax: {
      // 验证码图片背景色最大值
      type: Number,
      default: 255,
    },
    dotColorMin: {
      // 背景干扰点最小值
      type: Number,
      default: 20,
    },
    dotColorMax: {
      // 背景干扰点最大值
      type: Number,
      default: 20,
    },
    contentWidth: {
      // 容器宽度
      type: Number,
      default: 110,
    },
    contentHeight: {
      // 容器高度
      type: Number,
      default: 34,
    },
  },
  watch: {
    code() {
      this.drawPic();
    },
  },
  methods: {
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },

    randomColor(min, max) {
      const r = this.randomNum(min, max);
      const g = this.randomNum(min, max);
      const b = this.randomNum(min, max);
      return "rgb(" + r + "," + g + "," + b + ")";
    },

    drawPic() {
      const canvas = document.getElementById("picture-code");
      const ctx = canvas.getContext("2d");

      ctx.textBaseline = "bottom";

      // 绘制背景
      ctx.fillStyle = this.randomColor(
        this.backgroundColorMin,
        this.backgroundColorMax
      );
      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight);

      // 绘制文字
      for (let i = 0; i < this.code.length; i++) {
        this.drawText(ctx, this.code[i], i);
      }

      // 绘制干扰点
      this.drawDot(ctx, 16);
      this.drawLine(ctx, 2);
    },

    drawText(ctx, txt, i) {
      ctx.fillStyle = this.randomColor(0, 220); // 字体随机颜色
      ctx.font =
        this.randomNum(this.fontSizeMin, this.fontSizeMax) + "px SimHei"; // 随机生成字体大小

      const x = i * (this.contentWidth / (this.code.length + 1) + 4) + 12;
      const y = this.randomNum(this.fontSizeMax, this.contentHeight);
      const deg = this.randomNum(-30, 30);

      // 修改坐标原点和旋转角度
      ctx.translate(x, y);
      ctx.rotate((deg / 180) * Math.PI);
      ctx.fillText(txt, 0, 0);

      // 恢复坐标原点和旋转角度
      ctx.rotate((-deg / 180) * Math.PI);
      ctx.translate(-x, -y);
    },

    drawLine(ctx, count = 4) {
      // 绘制干扰线
      for (let i = 0; i < count; i++) {
        ctx.strokeStyle = this.randomColor(100, 200);
        ctx.beginPath();
        ctx.moveTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.lineTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.stroke();
      }
    },

    drawDot(ctx, count = 20) {
      // 绘制干扰点
      for (let i = 0; i < count; i++) {
        ctx.fillStyle = this.randomColor(0, 255);
        ctx.beginPath();
        ctx.arc(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight),
          1,
          0,
          2 * Math.PI
        );
        ctx.fill();
      }
    },
  },
  mounted() {
    this.drawPic();
  },
};
</script>

<style lang="scss" scoped>
.picture-code {
  padding: 2px 8px;
  border: $border-1;
  border-radius: 4px;
}
</style>